import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Project } from "../../../types/project";

type ProjectSuccessPageProps = {
  project: Project | null;
};

export default function ProjectSuccessPage({
  project,
}: ProjectSuccessPageProps) {
  const { t } = useTranslation();
  return (
    <Grid
      container
      sx={{
        flexDirection: {
          xs: "column",
          sm: "column",
          md: "column",
          lg: "row",
        },
      }}
    >
      <Grid item xs />
      <Grid item xs>
        <Grid container>
          <Grid item md={3} lg={1} xl={1} />
          <Grid item md={6} lg={10} xl={10}>
            <Box>
              <Typography variant={"h3"}>
                {t("projectSuccessPage.text1")}!
              </Typography>
            </Box>
            <Box>
              <Typography variant={"h4"}>
                {t("projectSuccessPage.text2")}
              </Typography>
            </Box>

            <Box mt={3}>{t("projectSuccessPage.text4")}</Box>
            {project?.skipLocalCoordinator ? null : (
              <Box mt={3}>
                <Typography>{t("projectSuccessPage.text9")}</Typography>
              </Box>
            )}
            <Box mt={3}>
              <Typography>{t("projectSuccessPage.text10")}</Typography>
            </Box>
            <Box>
              <List>
                <ListItem disableGutters key={1}>
                  <ListItemIcon>
                    <Typography fontWeight={"bold"}>1.</Typography>
                  </ListItemIcon>
                  {t("projectSuccessPage.getStarted1")}
                </ListItem>
                <ListItem disableGutters key={2}>
                  <ListItemIcon>
                    <Typography fontWeight={"bold"}>2.</Typography>
                  </ListItemIcon>
                  {t("projectSuccessPage.getStarted2")}
                </ListItem>
                <ListItem disableGutters key={3}>
                  <ListItemIcon>
                    <Typography fontWeight={"bold"}>3.</Typography>
                  </ListItemIcon>
                  {t("projectSuccessPage.getStarted3")}
                </ListItem>
                <ListItem disableGutters key={4}>
                  <ListItemIcon>
                    <Typography fontWeight={"bold"}>4.</Typography>
                  </ListItemIcon>
                  {t("projectSuccessPage.getStarted4")}
                </ListItem>
                <ListItem disableGutters key={5}>
                  <ListItemIcon>
                    <Typography fontWeight={"bold"}>5.</Typography>
                  </ListItemIcon>
                  {t("projectSuccessPage.getStarted5")}
                </ListItem>
                <ListItem disableGutters key={6}>
                  <ListItemIcon>
                    <Typography fontWeight={"bold"}>6.</Typography>
                  </ListItemIcon>
                  {t("projectSuccessPage.getStarted6")}
                </ListItem>
                <ListItem disableGutters key={7}>
                  <ListItemIcon>
                    <Typography fontWeight={"bold"}>7.</Typography>
                  </ListItemIcon>
                  {t("projectSuccessPage.getStarted7")}
                </ListItem>
                <ListItem disableGutters key={8}>
                  <ListItemIcon>
                    <Typography fontWeight={"bold"}>8.</Typography>
                  </ListItemIcon>
                  {t("projectSuccessPage.getStarted8")}
                </ListItem>
                <ListItem disableGutters key={9}>
                  <ListItemIcon>
                    <Typography fontWeight={"bold"}>9.</Typography>
                  </ListItemIcon>
                  {t("projectSuccessPage.getStarted9")}
                </ListItem>
                <ListItem disableGutters key={10}>
                  <ListItemIcon>
                    <Typography fontWeight={"bold"}>10.</Typography>
                  </ListItemIcon>
                  {t("projectSuccessPage.getStarted10")}
                </ListItem>
              </List>
            </Box>
          </Grid>
          <Grid item md={3} lg={1} xl={1} />
        </Grid>
      </Grid>
      <Grid item xs />
    </Grid>
  );
}
